import { Injectable } from '@angular/core';
import type { Plugin1cFindInterface } from '@zaoblako/shared/modules/integration/dtos/1c/plugin.1c.find.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Extension1CForm } from '@zaoblako/web/modules/admin/dumbs/extension1c-form/extension1c-form.component';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BasisSystem1cService extends BaseService {
  protected baseUrl = '/basis/system/plugin-1c';

  public download(): Observable<BlobPart> {
    return this.http.get<BlobPart>(`${this.baseUrl}/latest/download`, { responseType: 'arraybuffer' as any });
  }

  public downloadByVersion(version: string): Observable<BlobPart> {
    return this.http.get<BlobPart>(`${this.baseUrl}/${version}/download`, { responseType: 'arraybuffer' as any });
  }

  public getLatest(): Observable<Plugin1cFindInterface> {
    return this.http.get<Plugin1cFindInterface>(`${this.baseUrl}/latest`);
  }

  public setVersion(data: Extension1CForm): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${data.version}`, data.file);
  }

  public deleteByVersion(version: string): Observable<Plugin1cFindInterface> {
    return this.http.delete<Plugin1cFindInterface>(`${this.baseUrl}/${version}`);
  }
}
